import Dashboard, { DashboardPropsType } from "./Dashboard";
import React from "react";

const PaymentLayout: React.FunctionComponent<DashboardPropsType> = (props) => {
  return <Dashboard {...props} showBackdrop={false} />;
};

export default PaymentLayout;
